  (function () {
    var root = document.querySelector('[data-est-savings]');
    if (!root || root.dataset.estSavingsInit) return;
    root.dataset.estSavingsInit = 'true';

    // ── EDIT DEFAULTS HERE ──
    var DEFAULTS = {
      scenario: 'station',
      journeysPerWeek: 10,
      oneWayMiles: 2.5,
      workingWeeks: 48,
      replacementPct: 80,
      defaultCar: 'ford-puma',
      fuelPricePerLitre: 1.40,
      electricityPricePerKwh: 0.28,
      shortTripFactor: 1.25,
      carAvgMph: 8,
      bikeAvgMph: 15,
      co2PerMileIce: 0.404,
      parkingEnabled: true,
      parkingMode: 'season',
      parkingDaily: 10,
      parkingDaysPerWeek: 5,
      parkingSeason: 819,
      transitEnabled: false,
      transitAnnual: 1300,
      ebikeElectricity: 20,
      defaultModel: 'e20.X',
      c2wEnabled: false,
      c2wTaxBand: 'basic'
    };

    // ── EDIT BIKE PRICES HERE ──
    var BIKE_PRICES = {
      'e20.7': 1425,
      'e20.9': 1950,
      'e20.X': 1850,
      'e28.9': 1850,
      'e28.X': 1895,
      'L20 2.0': 2995,
      'G700': 3195,
      'H700': 3195
    };

    // NI rates: GOV.UK Category A employee rates (8% / 2%)
    var TAX_RATES = {
      basic: { tax: 0.20, ni: 0.08, label: 'Basic rate (20%)' },
      higher: { tax: 0.40, ni: 0.02, label: 'Higher rate (40%)' },
      additional: { tax: 0.45, ni: 0.02, label: 'Additional rate (45%)' }
    };

    // ── EDIT SCENARIO PRESETS HERE ──
    var SCENARIO_PRESETS = {
      station: {
        label: 'Commute to station',
        journeysPerWeek: 10,
        oneWayMiles: 2.5,
        workingWeeks: 48,
        parkingEnabled: true,
        parkingMode: 'season',
        parkingSeason: 819,
        parkingDaily: 10,
        parkingDaysPerWeek: 5,
        transitEnabled: false,
        transitAnnual: 0
      },
      school: {
        label: 'School run',
        journeysPerWeek: 10,
        oneWayMiles: 1.5,
        workingWeeks: 42,
        parkingEnabled: false,
        parkingMode: 'season',
        parkingSeason: 0,
        parkingDaily: 0,
        parkingDaysPerWeek: 5,
        transitEnabled: false,
        transitAnnual: 0
      },
      errands: {
        label: 'Local errands',
        journeysPerWeek: 6,
        oneWayMiles: 2.0,
        workingWeeks: 52,
        parkingEnabled: false,
        parkingMode: 'season',
        parkingSeason: 0,
        parkingDaily: 0,
        parkingDaysPerWeek: 5,
        transitEnabled: false,
        transitAnnual: 0
      }
    };

    // ── EDIT UK CAR DATA HERE (SMMT 2025 top sellers, WLTP combined for popular variant) ──
    // mpg = miles per UK gallon (petrol/diesel/hybrid/phev); miPerKwh = electric only
    var UK_POPULAR_CARS = [
      { id: 'custom', name: 'My car isn\'t listed', rank: 0, fuel: null, mpg: null, miPerKwh: null },
      { id: 'ford-puma', name: 'Ford Puma', rank: 1, fuel: 'petrol', mpg: 42.2, miPerKwh: null },
      { id: 'kia-sportage', name: 'Kia Sportage', rank: 2, fuel: 'hybrid', mpg: 44.1, miPerKwh: null },
      { id: 'nissan-qashqai', name: 'Nissan Qashqai', rank: 3, fuel: 'hybrid', mpg: 45.6, miPerKwh: null },
      { id: 'vauxhall-corsa', name: 'Vauxhall Corsa', rank: 4, fuel: 'petrol', mpg: 48.7, miPerKwh: null },
      { id: 'nissan-juke', name: 'Nissan Juke', rank: 5, fuel: 'petrol', mpg: 42.8, miPerKwh: null },
      { id: 'vw-golf', name: 'Volkswagen Golf', rank: 6, fuel: 'petrol', mpg: 44.8, miPerKwh: null },
      { id: 'volvo-xc40', name: 'Volvo XC40', rank: 7, fuel: 'hybrid', mpg: 47.9, miPerKwh: null },
      { id: 'mg-hs', name: 'MG HS', rank: 8, fuel: 'hybrid', mpg: 44.8, miPerKwh: null },
      { id: 'vw-tiguan', name: 'Volkswagen Tiguan', rank: 9, fuel: 'hybrid', mpg: 40.9, miPerKwh: null },
      { id: 'hyundai-tucson', name: 'Hyundai Tucson', rank: 10, fuel: 'hybrid', mpg: 44.1, miPerKwh: null },
      { id: 'tesla-model-y', name: 'Tesla Model Y', rank: 11, fuel: 'electric', mpg: null, miPerKwh: 4.0 },
      { id: 'toyota-yaris-cross', name: 'Toyota Yaris Cross', rank: 12, fuel: 'hybrid', mpg: 58.9, miPerKwh: null },
      { id: 'bmw-x1', name: 'BMW X1', rank: 13, fuel: 'hybrid', mpg: 44.1, miPerKwh: null },
      { id: 'mg-zs', name: 'MG ZS', rank: 14, fuel: 'hybrid', mpg: 48.7, miPerKwh: null },
      { id: 'mini-cooper', name: 'MINI Cooper', rank: 15, fuel: 'petrol', mpg: 44.1, miPerKwh: null },
      { id: 'jaecoo-7', name: 'Jaecoo 7', rank: 16, fuel: 'phev', mpg: 141.2, miPerKwh: null },
      { id: 'ford-kuga', name: 'Ford Kuga', rank: 17, fuel: 'hybrid', mpg: 47.9, miPerKwh: null },
      { id: 'peugeot-208', name: 'Peugeot 208', rank: 18, fuel: 'petrol', mpg: 48.7, miPerKwh: null },
      { id: 'kia-niro', name: 'Kia Niro', rank: 19, fuel: 'hybrid', mpg: 52.3, miPerKwh: null },
      { id: 'toyota-corolla', name: 'Toyota Corolla', rank: 20, fuel: 'hybrid', mpg: 58.9, miPerKwh: null },
      { id: 'toyota-yaris', name: 'Toyota Yaris', rank: 21, fuel: 'hybrid', mpg: 58.9, miPerKwh: null },
      { id: 'bmw-3-series', name: 'BMW 3 Series', rank: 22, fuel: 'hybrid', mpg: 44.1, miPerKwh: null },
      { id: 'tesla-model-3', name: 'Tesla Model 3', rank: 23, fuel: 'electric', mpg: null, miPerKwh: 4.2 },
      { id: 'vauxhall-mokka', name: 'Vauxhall Mokka', rank: 24, fuel: 'petrol', mpg: 42.8, miPerKwh: null },
      { id: 'renault-clio', name: 'Renault Clio', rank: 25, fuel: 'petrol', mpg: 47.9, miPerKwh: null },
      { id: 'dacia-sandero', name: 'Dacia Sandero', rank: 26, fuel: 'petrol', mpg: 48.7, miPerKwh: null },
      { id: 'mercedes-a-class', name: 'Mercedes A-Class', rank: 27, fuel: 'petrol', mpg: 40.9, miPerKwh: null },
      { id: 'ford-focus', name: 'Ford Focus', rank: 28, fuel: 'petrol', mpg: 42.8, miPerKwh: null },
      { id: 'audi-q4-etron', name: 'Audi Q4 e-tron', rank: 29, fuel: 'electric', mpg: null, miPerKwh: 3.6 },
      { id: 'bmw-x3', name: 'BMW X3', rank: 30, fuel: 'hybrid', mpg: 40.4, miPerKwh: null },
      { id: 'kia-picanto', name: 'Kia Picanto', rank: 31, fuel: 'petrol', mpg: 50.4, miPerKwh: null },
      { id: 'hyundai-kona', name: 'Hyundai Kona', rank: 32, fuel: 'hybrid', mpg: 50.4, miPerKwh: null },
      { id: 'peugeot-2008', name: 'Peugeot 2008', rank: 33, fuel: 'petrol', mpg: 44.8, miPerKwh: null },
      { id: 'skoda-octavia', name: 'Skoda Octavia', rank: 34, fuel: 'petrol', mpg: 44.8, miPerKwh: null },
      { id: 'toyota-chr', name: 'Toyota C-HR', rank: 35, fuel: 'hybrid', mpg: 50.4, miPerKwh: null },
      { id: 'range-rover-evoque', name: 'Range Rover Evoque', rank: 36, fuel: 'hybrid', mpg: 40.9, miPerKwh: null },
      { id: 'hyundai-i10', name: 'Hyundai i10', rank: 37, fuel: 'petrol', mpg: 48.7, miPerKwh: null },
      { id: 'citroen-c3', name: 'Citroën C3', rank: 38, fuel: 'petrol', mpg: 47.9, miPerKwh: null },
      { id: 'vw-polo', name: 'Volkswagen Polo', rank: 39, fuel: 'petrol', mpg: 48.7, miPerKwh: null },
      { id: 'mercedes-glc', name: 'Mercedes GLC', rank: 40, fuel: 'hybrid', mpg: 40.4, miPerKwh: null },
      { id: 'audi-q3', name: 'Audi Q3', rank: 41, fuel: 'petrol', mpg: 40.4, miPerKwh: null },
      { id: 'seat-leon', name: 'SEAT Leon', rank: 42, fuel: 'petrol', mpg: 44.8, miPerKwh: null },
      { id: 'bmw-1-series', name: 'BMW 1 Series', rank: 43, fuel: 'petrol', mpg: 42.8, miPerKwh: null },
      { id: 'byd-seal-u', name: 'BYD Seal U', rank: 44, fuel: 'phev', mpg: 156.9, miPerKwh: null },
      { id: 'volvo-ex30', name: 'Volvo EX30', rank: 45, fuel: 'electric', mpg: null, miPerKwh: 3.8 },
      { id: 'skoda-kodiaq', name: 'Skoda Kodiaq', rank: 46, fuel: 'hybrid', mpg: 40.9, miPerKwh: null },
      { id: 'renault-captur', name: 'Renault Captur', rank: 47, fuel: 'hybrid', mpg: 47.9, miPerKwh: null },
      { id: 'mazda-cx-5', name: 'Mazda CX-5', rank: 48, fuel: 'petrol', mpg: 40.4, miPerKwh: null },
      { id: 'audi-a3', name: 'Audi A3', rank: 49, fuel: 'petrol', mpg: 44.8, miPerKwh: null },
      { id: 'ford-puma-gen-e', name: 'Ford Puma Gen-E', rank: 50, fuel: 'electric', mpg: null, miPerKwh: 3.7 }
    ];

    var FUEL_LABELS = {
      petrol: 'Petrol',
      diesel: 'Diesel',
      hybrid: 'Hybrid',
      phev: 'Plug-in hybrid',
      electric: 'Electric'
    };

    var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
    var gbp2 = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    var state = {
      activePreset: DEFAULTS.scenario,
      efficiencyOverride: null,
      currentStep: 1,
      totalSteps: 5,
      lastResult: null,
      submitting: false
    };

    var carSelect = root.querySelector('[data-est-savings-car]');
    var carBadge = root.querySelector('[data-est-savings-car-badge]');
    var customCarEl = root.querySelector('[data-est-savings-custom-car]');
    var efficiencyEditEl = root.querySelector('[data-est-savings-efficiency-edit]');
    var efficiencyOverrideInput = root.querySelector('[data-est-savings-efficiency-override]');
    var efficiencyLabel = root.querySelector('[data-est-savings-efficiency-label]');
    var customFuelSelect = root.querySelector('[data-est-savings-custom-fuel]');
    var customEfficiencyInput = root.querySelector('[data-est-savings-custom-efficiency]');
    var customEfficiencyLabel = root.querySelector('[data-est-savings-custom-efficiency-label]');
    var bikeSelect = root.querySelector('[data-est-savings-bike]');
    var replacementSlider = root.querySelector('[data-est-savings-replacement]');
    var replacementValue = root.querySelector('[data-est-savings-replacement-value]');
    var c2wCheckbox = root.querySelector('[data-est-savings-c2w]');
    var c2wFields = root.querySelector('[data-est-savings-c2w-fields]');
    var c2wTaxSelect = root.querySelector('[data-est-savings-c2w-tax]');
    var c2wStat = root.querySelector('[data-est-savings-c2w-stat]');
    var fuelPriceLabel = root.querySelector('[data-est-savings-fuel-price-label]');
    var fuelPriceInput = root.querySelector('[data-est-savings-fuel-price]');
    var progressFill = root.querySelector('[data-est-savings-progress-fill]');
    var backBtn = root.querySelector('[data-est-savings-back]');
    var nextBtn = root.querySelector('[data-est-savings-next]');
    var submitBtn = root.querySelector('[data-est-savings-submit]');
    var skipBtn = root.querySelector('[data-est-savings-skip]');
    var emailInput = root.querySelector('[data-est-savings-email]');
    var emailResultsCheckbox = root.querySelector('[data-est-savings-email-results]');
    var newsletterCheckbox = root.querySelector('[data-est-savings-newsletter]');
    var emailSummary = root.querySelector('[data-est-savings-email-summary]');
    var statusSuccess = root.querySelector('[data-est-savings-status-success]');
    var statusError = root.querySelector('[data-est-savings-status-error]');
    var contactForm = root.querySelector('#est-savings-contact-form');
    var newsletterForm = root.querySelector('#est-savings-newsletter-form');
    var stepEls = root.querySelectorAll('[data-est-savings-step]');
    var progressLabels = root.querySelectorAll('[data-est-savings-progress-label]');

    function getCarById(id) {
      for (var i = 0; i < UK_POPULAR_CARS.length; i++) {
        if (UK_POPULAR_CARS[i].id === id) return UK_POPULAR_CARS[i];
      }
      return UK_POPULAR_CARS[1];
    }

    function isElectricFuel(fuel) {
      return fuel === 'electric';
    }

    function populateCarSelect() {
      var sorted = UK_POPULAR_CARS.slice().sort(function (a, b) {
        if (a.id === 'custom') return -1;
        if (b.id === 'custom') return 1;
        return a.name.localeCompare(b.name);
      });

      var html = '';
      sorted.forEach(function (car) {
        html += '<option value="' + car.id + '">' + car.name + '</option>';
      });
      carSelect.innerHTML = html;
      carSelect.value = DEFAULTS.defaultCar;
    }

    function getActiveCar() {
      var car = getCarById(carSelect.value);
      if (car.id === 'custom') {
        var fuel = customFuelSelect.value;
        var efficiency = parseFloat(customEfficiencyInput.value) || 0;
        return {
          id: 'custom',
          name: 'Custom',
          fuel: fuel,
          mpg: isElectricFuel(fuel) ? null : efficiency,
          miPerKwh: isElectricFuel(fuel) ? efficiency : null
        };
      }

      var result = {
        id: car.id,
        name: car.name,
        fuel: car.fuel,
        mpg: car.mpg,
        miPerKwh: car.miPerKwh
      };

      if (state.efficiencyOverride !== null) {
        if (isElectricFuel(car.fuel)) {
          result.miPerKwh = state.efficiencyOverride;
        } else {
          result.mpg = state.efficiencyOverride;
        }
      }

      return result;
    }

    function updateEfficiencyLabels(fuel) {
      var isEv = isElectricFuel(fuel);
      var label = isEv ? 'mi/kWh' : 'MPG (WLTP combined)';
      efficiencyLabel.textContent = label;
      customEfficiencyLabel.textContent = label;
      fuelPriceLabel.textContent = isEv ? 'Electricity price (£/kWh)' : 'Fuel price (£/litre)';
      if (isEv && parseFloat(fuelPriceInput.value) === DEFAULTS.fuelPricePerLitre) {
        fuelPriceInput.value = DEFAULTS.electricityPricePerKwh;
        fuelPriceInput.step = '0.01';
      } else if (!isEv && parseFloat(fuelPriceInput.value) === DEFAULTS.electricityPricePerKwh) {
        fuelPriceInput.value = DEFAULTS.fuelPricePerLitre;
        fuelPriceInput.step = '0.01';
      }
    }

    function updateCarUI() {
      var car = getCarById(carSelect.value);
      var isCustom = car.id === 'custom';

      customCarEl.hidden = !isCustom;
      efficiencyEditEl.hidden = isCustom || state.efficiencyOverride === null;

      if (isCustom) {
        efficiencyEditEl.hidden = true;
        state.efficiencyOverride = null;
        carBadge.innerHTML = '<strong>Custom vehicle</strong> — enter your details below';
        updateEfficiencyLabels(customFuelSelect.value);
        return;
      }

      efficiencyEditEl.hidden = state.efficiencyOverride === null;

      var active = getActiveCar();
      updateEfficiencyLabels(active.fuel);

      var efficiencyText = isElectricFuel(active.fuel)
        ? (active.miPerKwh + ' mi/kWh')
        : (active.mpg + ' MPG');

      carBadge.innerHTML = '<strong>' + active.name + '</strong> · ' +
        (FUEL_LABELS[active.fuel] || active.fuel) + ' · ' + efficiencyText;
    }

    function applyPreset(presetKey) {
      if (presetKey === 'custom') {
        state.activePreset = 'custom';
        updatePresetButtons();
        calculate();
        return;
      }

      var preset = SCENARIO_PRESETS[presetKey];
      if (!preset) return;

      state.activePreset = presetKey;

      root.querySelector('[data-est-savings-journeys]').value = preset.journeysPerWeek;
      root.querySelector('[data-est-savings-distance]').value = preset.oneWayMiles;
      root.querySelector('[data-est-savings-weeks]').value = preset.workingWeeks;
      root.querySelector('[data-est-savings-parking-enabled]').checked = preset.parkingEnabled;
      root.querySelector('[data-est-savings-parking-mode]').value = preset.parkingMode;
      root.querySelector('[data-est-savings-parking-season-amount]').value = preset.parkingSeason;
      root.querySelector('[data-est-savings-parking-daily-amount]').value = preset.parkingDaily;
      root.querySelector('[data-est-savings-parking-days]').value = preset.parkingDaysPerWeek;
      root.querySelector('[data-est-savings-transit-enabled]').checked = preset.transitEnabled;
      root.querySelector('[data-est-savings-transit-amount]').value = preset.transitAnnual;

      updateParkingUI();
      updateTransitUI();
      updatePresetButtons();
      calculate();
    }

    function updatePresetButtons() {
      root.querySelectorAll('[data-est-savings-preset]').forEach(function (btn) {
        var isActive = btn.dataset.estSavingsPreset === state.activePreset;
        btn.classList.toggle('est-savings__preset--active', isActive);
      });
    }

    function updateParkingUI() {
      var enabled = root.querySelector('[data-est-savings-parking-enabled]').checked;
      var fields = root.querySelector('[data-est-savings-parking-fields]');
      var mode = root.querySelector('[data-est-savings-parking-mode]').value;

      fields.hidden = !enabled;
      root.querySelector('[data-est-savings-parking-season]').hidden = mode !== 'season';
      root.querySelector('[data-est-savings-parking-daily]').hidden = mode !== 'daily';
    }

    function updateTransitUI() {
      var enabled = root.querySelector('[data-est-savings-transit-enabled]').checked;
      root.querySelector('[data-est-savings-transit-fields]').hidden = !enabled;
    }

    function formatPayback(months) {
      if (!isFinite(months) || months <= 0) return '—';
      if (months < 1) return '< 1 mo';
      return Math.round(months) + ' mo';
    }

    function getContextMessage(result) {
      var netSaving = result.netSaving;
      var payback = result.paybackMonths;
      var fuel = result.fuelCost;
      var parking = result.parkingCost;
      var transit = result.transitCost;
      var total = result.totalCarCost;
      var car = getActiveCar();

      if (netSaving < 50 && isElectricFuel(car.fuel)) {
        return 'Already low running costs — but imagine skipping the traffic too.';
      }
      if (payback > 0 && payback < 12) {
        return 'This bike could pay for itself in under a year.';
      }
      if (payback >= 12 && payback <= 24) {
        return 'That\'s less than two years to break even — then it\'s pure saving.';
      }
      if (parking > fuel && parking > 0) {
        return 'You\'re spending more on parking than petrol.';
      }
      if (transit > 0 && total > 1000) {
        return 'Add it up and you\'re paying nearly ' + gbp.format(Math.round(total)) + ' a year just getting around.';
      }
      if (netSaving > 0) {
        return 'Every short trip you switch to an e-bike puts money back in your pocket.';
      }
      return 'Adjust your inputs above to see your personalised estimate.';
    }

    function buildResultsSummary(result) {
      var car = getActiveCar();
      var scenarioLabel = SCENARIO_PRESETS[state.activePreset]
        ? SCENARIO_PRESETS[state.activePreset].label
        : 'Custom';
      var lines = [
        'Estarli Savings Calculator Results',
        '────────────────────────────────',
        'Scenario: ' + scenarioLabel,
        'Car: ' + car.name + ' (' + (FUEL_LABELS[car.fuel] || car.fuel) + ')',
        'E-bike: ' + bikeSelect.value,
        'Trips switched: ' + replacementSlider.value + '%',
        '',
        'Annual saving: ' + gbp.format(Math.round(result.netSaving)),
        'Per trip: ' + gbp2.format(result.perTripSaving),
        '5-year cost of inaction: ' + gbp.format(Math.round(result.fiveYearCost)),
        'Payback (RRP): ' + formatPayback(result.paybackMonths),
        '',
        'Breakdown:',
        '- Fuel/electricity: ' + gbp.format(Math.round(result.fuelCost)),
        '- Parking: ' + gbp.format(Math.round(result.parkingCost)),
        '- Public transport: ' + gbp.format(Math.round(result.transitCost)),
        '- E-bike running cost: ' + gbp.format(Math.round(root.querySelector('[data-est-savings-ebike-electricity]').value || 0)),
        '',
        'Time saved: ~' + Math.round(Math.max(0, result.timeSavedHrs)) + ' hrs/year',
        'CO2 avoided: ' + Math.round(Math.max(0, result.co2SavedKg)) + ' kg/year',
        '',
        'Illustrative estimate only. Excludes insurance, MOT, and depreciation.',
        'https://www.estarli.co.uk'
      ];

      if (result.c2wPaybackMonths > 0) {
        lines.splice(10, 0, 'Payback (cycle scheme): ' + formatPayback(result.c2wPaybackMonths));
      }

      return lines.join('\n');
    }

    function updateEmailSummary() {
      if (!state.lastResult) return;
      var result = state.lastResult;
      emailSummary.innerHTML =
        'You could save <strong>' + gbp.format(Math.round(result.netSaving)) + '</strong> per year ' +
        '(' + gbp2.format(result.perTripSaving) + ' per trip) with an ' + bikeSelect.value + '.';
    }

    function goToStep(step) {
      state.currentStep = Math.max(1, Math.min(state.totalSteps, step));

      stepEls.forEach(function (el) {
        var stepNum = parseInt(el.dataset.estSavingsStep, 10);
        var isActive = stepNum === state.currentStep;
        el.hidden = !isActive;
        el.classList.toggle('est-savings__step--active', isActive);
      });

      progressFill.style.width = ((state.currentStep / state.totalSteps) * 100) + '%';

      progressLabels.forEach(function (label) {
        var stepNum = parseInt(label.dataset.estSavingsProgressLabel, 10);
        label.classList.toggle('est-savings__progress-step--active', stepNum === state.currentStep);
        label.classList.toggle('est-savings__progress-step--done', stepNum < state.currentStep);
      });

      backBtn.hidden = state.currentStep === 1;
      nextBtn.hidden = state.currentStep >= 5;
      submitBtn.hidden = state.currentStep !== 5;
      skipBtn.hidden = state.currentStep !== 5;
      nextBtn.textContent = state.currentStep === 4 ? 'Save my results' : 'Next';

      if (state.currentStep === 4) {
        calculate();
      }

      if (state.currentStep === 5) {
        updateEmailSummary();
        statusSuccess.hidden = true;
        statusError.hidden = true;
      }

      root.querySelector('.est-savings__card').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function submitShopifyForm(formEl) {
      if (!formEl) return Promise.resolve({ ok: false, skipped: true });

      var formData = new FormData(formEl);
      var tokenInput = document.querySelector('input[name="authenticity_token"]');

      if (tokenInput && tokenInput.value) {
        formData.set('authenticity_token', tokenInput.value);
      }

      return fetch(formEl.action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        }).catch(function () {
          return { ok: response.ok, data: null };
        });
      });
    }

    function handleLeadSubmit() {
      if (state.submitting) return;

      var email = emailInput.value.trim();
      var wantsResults = emailResultsCheckbox.checked;
      var wantsNewsletter = newsletterCheckbox.checked;

      if (!email) {
        statusError.textContent = 'Please enter your email address.';
        statusError.hidden = false;
        statusSuccess.hidden = true;
        emailInput.focus();
        return;
      }

      if (!wantsResults && !wantsNewsletter) {
        statusError.textContent = 'Please select at least one option, or choose Skip for now.';
        statusError.hidden = false;
        statusSuccess.hidden = true;
        return;
      }

      state.submitting = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      statusError.hidden = true;
      statusSuccess.hidden = true;

      var tasks = [];

      if (wantsResults && contactForm && state.lastResult) {
        contactForm.querySelector('[data-est-savings-contact-email]').value = email;
        contactForm.querySelector('[data-est-savings-contact-body]').value =
          'Please email the following Estarli savings calculator results to the customer at ' + email + ':\n\n' +
          buildResultsSummary(state.lastResult);
        tasks.push(submitShopifyForm(contactForm));
      }

      if (wantsNewsletter && newsletterForm) {
        newsletterForm.querySelector('[data-est-savings-newsletter-email]').value = email;
        tasks.push(submitShopifyForm(newsletterForm));
      }

      Promise.all(tasks).then(function (results) {
        var failed = results.some(function (result) {
          return result && !result.skipped && (!result.ok || (result.data && result.data.errors));
        });

        if (failed) {
          statusError.textContent = 'Something went wrong. Please try again or contact us directly.';
          statusError.hidden = false;
        } else {
          var messages = [];
          if (wantsResults) messages.push('Your results have been sent.');
          if (wantsNewsletter) messages.push('You\'re subscribed to our newsletter.');
          statusSuccess.textContent = messages.join(' ');
          statusSuccess.hidden = false;
          emailInput.value = '';
        }
      }).catch(function () {
        statusError.textContent = 'Something went wrong. Please try again.';
        statusError.hidden = false;
      }).finally(function () {
        state.submitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send my results';
      });
    }

    function calculate() {
      var car = getActiveCar();
      var replacementPct = parseFloat(replacementSlider.value) || DEFAULTS.replacementPct;
      var replacementFactor = replacementPct / 100;

      var journeysPerWeek = parseFloat(root.querySelector('[data-est-savings-journeys]').value) || 0;
      var oneWayMiles = Math.min(parseFloat(root.querySelector('[data-est-savings-distance]').value) || 0, 5);
      var workingWeeks = parseFloat(root.querySelector('[data-est-savings-weeks]').value) || 0;

      var annualTrips = journeysPerWeek * workingWeeks * replacementFactor;
      var annualMiles = oneWayMiles * 2 * annualTrips;

      var fuelPrice = parseFloat(fuelPriceInput.value) || 0;
      var fuelCost = 0;

      if (isElectricFuel(car.fuel)) {
        var miPerKwh = car.miPerKwh || 3.5;
        if (annualMiles > 0 && miPerKwh > 0) {
          fuelCost = (annualMiles / miPerKwh) * fuelPrice;
        }
      } else {
        var wltpMpg = car.mpg || 40;
        var effectiveMpg = wltpMpg / DEFAULTS.shortTripFactor;
        if (annualMiles > 0 && effectiveMpg > 0) {
          var litresPerMile = 4.54609 / effectiveMpg;
          fuelCost = annualMiles * litresPerMile * fuelPrice;
        }
      }

      var parkingCost = 0;
      if (root.querySelector('[data-est-savings-parking-enabled]').checked) {
        if (root.querySelector('[data-est-savings-parking-mode]').value === 'season') {
          parkingCost = parseFloat(root.querySelector('[data-est-savings-parking-season-amount]').value) || 0;
        } else {
          var daily = parseFloat(root.querySelector('[data-est-savings-parking-daily-amount]').value) || 0;
          var days = parseFloat(root.querySelector('[data-est-savings-parking-days]').value) || 0;
          parkingCost = daily * days * workingWeeks;
        }
        parkingCost *= replacementFactor;
      }

      var transitCost = 0;
      if (root.querySelector('[data-est-savings-transit-enabled]').checked) {
        transitCost = (parseFloat(root.querySelector('[data-est-savings-transit-amount]').value) || 0) * replacementFactor;
      }

      var ebikeCost = parseFloat(root.querySelector('[data-est-savings-ebike-electricity]').value) || 0;
      var totalCarCost = fuelCost + parkingCost + transitCost;
      var netSaving = Math.max(0, totalCarCost - ebikeCost);

      var tripDivisor = journeysPerWeek * workingWeeks * replacementFactor;
      var perTripSaving = tripDivisor > 0 ? netSaving / tripDivisor : 0;
      var fiveYearCost = totalCarCost * 5;

      var bikeRRP = BIKE_PRICES[bikeSelect.value] || 0;
      var paybackMonths = netSaving > 0 ? (bikeRRP / netSaving) * 12 : 0;

      var c2wEnabled = c2wCheckbox.checked;
      var c2wPaybackMonths = 0;
      var schemeNetPrice = bikeRRP;

      if (c2wEnabled && netSaving > 0) {
        var taxBand = TAX_RATES[c2wTaxSelect.value] || TAX_RATES.basic;
        var totalSaved = bikeRRP * (taxBand.tax + taxBand.ni);
        schemeNetPrice = bikeRRP - totalSaved;
        c2wPaybackMonths = (schemeNetPrice / netSaving) * 12;
      }

      var carHoursPerTrip = oneWayMiles / DEFAULTS.carAvgMph;
      var bikeHoursPerTrip = oneWayMiles / DEFAULTS.bikeAvgMph;
      var timeSavedHrs = annualTrips * (carHoursPerTrip - bikeHoursPerTrip) * 2;
      var co2SavedKg = isElectricFuel(car.fuel) ? 0 : annualMiles * DEFAULTS.co2PerMileIce;

      var result = {
        fuelCost: fuelCost,
        parkingCost: parkingCost,
        transitCost: transitCost,
        totalCarCost: totalCarCost,
        netSaving: netSaving,
        perTripSaving: perTripSaving,
        fiveYearCost: fiveYearCost,
        paybackMonths: paybackMonths,
        c2wPaybackMonths: c2wPaybackMonths,
        timeSavedHrs: timeSavedHrs,
        co2SavedKg: co2SavedKg
      };

      state.lastResult = result;

      root.querySelector('[data-est-savings-hero-annual]').textContent = gbp.format(Math.round(netSaving));
      root.querySelector('[data-est-savings-per-trip]').textContent = gbp2.format(perTripSaving);
      root.querySelector('[data-est-savings-five-year]').textContent = gbp.format(Math.round(fiveYearCost));
      root.querySelector('[data-est-savings-payback]').textContent = formatPayback(paybackMonths);
      root.querySelector('[data-est-savings-context]').textContent = getContextMessage(result);

      root.querySelector('[data-est-savings-breakdown-fuel]').textContent = gbp.format(Math.round(fuelCost));
      root.querySelector('[data-est-savings-breakdown-parking]').textContent = gbp.format(Math.round(parkingCost));
      root.querySelector('[data-est-savings-breakdown-transit]').textContent = gbp.format(Math.round(transitCost));
      root.querySelector('[data-est-savings-breakdown-ebike]').textContent = gbp.format(Math.round(ebikeCost));

      root.querySelector('[data-est-savings-time-saved]').textContent = '~' + Math.round(Math.max(0, timeSavedHrs)) + ' hrs/yr';
      root.querySelector('[data-est-savings-co2]').textContent = Math.round(Math.max(0, co2SavedKg)) + ' kg/yr';

      c2wStat.hidden = !c2wEnabled;
      if (c2wEnabled) {
        root.querySelector('[data-est-savings-c2w-payback]').textContent = formatPayback(c2wPaybackMonths);
      }
    }

    root.querySelectorAll('[data-est-savings-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyPreset(btn.dataset.estSavingsPreset);
        if (btn.dataset.estSavingsPreset === 'custom') {
          goToStep(3);
        }
      });
    });

    backBtn.addEventListener('click', function () {
      goToStep(state.currentStep - 1);
    });

    nextBtn.addEventListener('click', function () {
      goToStep(state.currentStep + 1);
    });

    skipBtn.addEventListener('click', function () {
      goToStep(4);
    });

    submitBtn.addEventListener('click', handleLeadSubmit);

    root.querySelector('[data-est-savings-edit-efficiency]').addEventListener('click', function () {
      var car = getCarById(carSelect.value);
      if (car.id === 'custom') return;

      var active = getActiveCar();
      state.efficiencyOverride = isElectricFuel(active.fuel) ? active.miPerKwh : active.mpg;
      efficiencyOverrideInput.value = state.efficiencyOverride;
      updateEfficiencyLabels(active.fuel);
      efficiencyEditEl.hidden = false;
      calculate();
    });

    efficiencyOverrideInput.addEventListener('input', function () {
      state.efficiencyOverride = parseFloat(efficiencyOverrideInput.value) || null;
      var car = getActiveCar();
      var efficiencyText = isElectricFuel(car.fuel)
        ? (car.miPerKwh + ' mi/kWh')
        : (car.mpg + ' MPG');
      carBadge.innerHTML = '<strong>' + car.name + '</strong> · ' +
        (FUEL_LABELS[car.fuel] || car.fuel) + ' · ' + efficiencyText;
      calculate();
    });

    carSelect.addEventListener('change', function () {
      state.efficiencyOverride = null;
      efficiencyEditEl.hidden = true;
      state.activePreset = 'custom';
      updatePresetButtons();
      updateCarUI();
      calculate();
    });

    customFuelSelect.addEventListener('change', function () {
      updateEfficiencyLabels(customFuelSelect.value);
      calculate();
    });

    customEfficiencyInput.addEventListener('input', calculate);

    replacementSlider.addEventListener('input', function () {
      replacementValue.textContent = replacementSlider.value + '%';
      calculate();
    });

    c2wCheckbox.addEventListener('change', function () {
      c2wFields.hidden = !c2wCheckbox.checked;
      calculate();
    });

    function onAdvancedChange() {
      state.activePreset = 'custom';
      updatePresetButtons();
      updateParkingUI();
      updateTransitUI();
      calculate();
    }

    var advancedInputs = root.querySelector('[data-est-savings-step="3"]').querySelectorAll('input:not([data-est-savings-c2w]), select');
    advancedInputs.forEach(function (el) {
      el.addEventListener('input', onAdvancedChange);
      el.addEventListener('change', onAdvancedChange);
    });

    populateCarSelect();
    bikeSelect.value = DEFAULTS.defaultModel;
    replacementSlider.value = DEFAULTS.replacementPct;
    replacementValue.textContent = DEFAULTS.replacementPct + '%';
    c2wFields.hidden = true;
    updateParkingUI();
    updateTransitUI();
    applyPreset(DEFAULTS.scenario);
    updateCarUI();
    calculate();
    goToStep(1);
  })();
